var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key-round",
    clipPath: "url(#clip0_0_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.4994 14.1214C1.49948 13.7236 1.65759 13.3421 1.93894 13.0608L7.04989 7.94985C6.68675 6.90738 6.68813 5.77254 7.05382 4.73096C7.41951 3.68938 8.12785 2.80274 9.06297 2.21608C9.99808 1.62942 11.1046 1.37747 12.2015 1.50145C13.2985 1.62544 14.3208 2.11801 15.1014 2.89859C15.882 3.67917 16.3746 4.70154 16.4985 5.79847C16.6225 6.89539 16.3706 8.00192 15.7839 8.93703C15.1973 9.87215 14.3106 10.5805 13.269 10.9462C12.2275 11.3119 11.0926 11.3133 10.0501 10.9501L9.4396 11.5607C9.15833 11.842 8.77683 12.0001 8.379 12.0002H8.24999C8.05106 12.0002 7.86028 12.0792 7.71961 12.2199C7.57895 12.3606 7.49993 12.5513 7.49993 12.7503V13.5003C7.49993 13.6993 7.4209 13.8901 7.28024 14.0307C7.13957 14.1714 6.94879 14.2504 6.74986 14.2504H5.99979C5.80086 14.2504 5.61008 14.3294 5.46942 14.4701C5.32875 14.6108 5.24973 14.8015 5.24973 15.0005V15.7505C5.24973 15.9495 5.1707 16.1402 5.03004 16.2809C4.88937 16.4216 4.69859 16.5006 4.49966 16.5006H2.24947C2.05054 16.5006 1.85975 16.4216 1.71909 16.2809C1.57842 16.1402 1.4994 15.9495 1.4994 15.7505V14.1214Z",
    stroke: "#1B8C5A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.29136c2bea58254e2126428a815ed86a.svg";
export { ForwardRef as ReactComponent };